import { registerComponent } from './components-front'
import { tns } from 'tiny-slider'

registerComponent('franchisee-news-carousel', _ => {
    document.querySelectorAll('.franchisee-news-carousel-wrapper').forEach(carouselWrapper => {
        const carousel = carouselWrapper.querySelector('.franchisee-news-carousel')
        const cols = carousel.dataset.cols || 2

        /** @var {HTMLDivElement} prev */
        const prev = carouselWrapper.querySelector('.prev')
        /** @var {HTMLDivElement} next */
        const next = carouselWrapper.querySelector('.next')

        const slider = tns({
            container: carousel,
            autoHeight: true,
            items: 1,
            slideBy: 1,
            nav: false,
            prevButton: prev,
            nextButton: next,
            arrowKeys: true,
            responsive: {
                768: {
                    items: cols,
                    gutter: 56,
                },
            },
        })
    })
})

registerComponent('filtered-article', _ => {
    document.querySelectorAll('.article-filter').forEach(filter => {
        const select = filter.querySelector('select')
        const button = filter.querySelector('button')
        //NEW FUNCTIONALITY FOR MY USE - RYAN
        button.addEventListener('click', _ => {
            document.querySelectorAll('.article').forEach(article => {
                article.classList.remove('d-none')
                select.selectedIndex = 0
            })
        })



        select.addEventListener('change', _=> {
            document.querySelectorAll('.article').forEach(article => {
                const tags = JSON.parse(article.dataset.tags)
                if (isNaN(select.value) || tags.includes(+select.value)) {
                    article.classList.remove('d-none')
                } else {
                    article.classList.add('d-none')
                }
            })
        })

        // OLD FUNCTIONALITY FROM THE ORIGINAL USE

        // button.addEventListener('click', _ => {
        //     document.querySelectorAll('.article').forEach(article => {
        //         const tags = JSON.parse(article.dataset.tags)
        //         if (isNaN(select.value) || tags.includes(+select.value)) {
        //             article.classList.remove('d-none')
        //         } else {
        //             article.classList.add('d-none')
        //         }
        //     })
        // })
    })
})